var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"invoiceDataEditModal","size":"xl","hide-footer":""}},[_c('b-row',{attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('b-col',[_c('h6',[_vm._v(_vm._s(_vm.$t('views.exsbinvoices.invoiceDataEditModal.header')))])])],1),_c('Update',{attrs:{"openInModal":true,"editType":'data',"idInvoice":_vm.idInvoice}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }